module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/fv-bg-pc-39e7fb26399303722c7385b3c8adbec9.jpg";